import React, { useEffect } from "react";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import FloatingNav from "./components/FloatingNav";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import SkillsSection from "./components/SkillsSection";
import ExperienceSection from "./components/ExperienceSection";
import PatentSection from "./components/PatentSection";
import ProjectsSection from "./components/ProjectsSection";
import ContactSection from "./components/ContactSection";
import ViewCounter from "./components/ui/ViewCounter";
import { patents } from "./data/mockData";

function TitleSetter() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Rahul Singh | Dossier";
  }, [location]);

  return null; // nothing to render
}

function AppContent() {
  const { isDark, isInitialized } = useTheme();

  // Show loading screen until theme is initialized to prevent flash
  if (!isInitialized) {
    return (
      <div className="App overflow-x-hidden bg-gray-900 text-white" 
           style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400 mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className={`App overflow-x-hidden ${
      isDark ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'
    }`}
    style={{
      transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
      minHeight: '100vh'
    }}>
      <FloatingNav />
      <ViewCounter position="bottom-right" />
      <HeroSection />
      <AboutSection />
      {patents.length >= 1 && <PatentSection />}
      <SkillsSection />
      <ExperienceSection />
      <ProjectsSection />
      <ContactSection />
    </div>
  );
}


function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <TitleSetter />
        <Routes>
          <Route path="/" element={<AppContent />} />
          <Route path="/dossier" element={<AppContent />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </ThemeProvider>
  );
}

export default App;